import ParentLessonHistory from "@/elements/components/lesson-history/parent-lesson-history";
import TutorLessonHistory from "@/elements/components/lesson-history/tutor-lesson-history";
import Loader from "@/elements/components/shared/loader";
import { api } from "@/elements/components/utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment } from "react";
import { View } from "react-native";

function LessonHistoryScreen() {
  const { data: currentUser, isSuccess: isCurrentUserSuccess } = useQuery(
    convexQuery(api.account.queries.getCurrentUser, {})
  );
  const persona = currentUser?.persona;

  if (!isCurrentUserSuccess) {
    return <Loader />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      {persona === "parent" ? (
        <ParentLessonHistory />
      ) : persona === "tutor" ? (
        <TutorLessonHistory />
      ) : (
        <Fragment />
      )}
    </View>
  );
}

export default LessonHistoryScreen;
